import { FC, useEffect } from 'react';
import { Fade, Paper, Box, Typography, Button } from '@mui/material';
import StreetCoverBanner from '../../components/banner/StreetCoverDeclinedBanner';
import { useNavigate } from 'react-router';
import Home from '@mui/icons-material/Home';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { clearMidTermAdjustmentDetails } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { clearMidTermAdjustmentResponseDetails } from '@acorn-portal/shared/src/store/midTermAdjustmentRatingResponse.slice';

const MtaReferralPage: FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		return () => {
			dispatch(clearMidTermAdjustmentDetails());
			dispatch(clearMidTermAdjustmentResponseDetails());
		};
	}, [dispatch]);

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box>
					<StreetCoverBanner
						text={
							<Box
								sx={(theme) => ({
									[theme.breakpoints.down('md')]: { fontSize: '1.3rem' },
								})}
							>
								We&apos;re reviewing your quote
							</Box>
						}
					/>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							textAlign: 'center',
							px: 2,
							'& > *': { mb: 3 },
						}}
					>
						<Box
							sx={(theme) => ({
								mt: 4,
								mx: '10%',
								'& > *': { mb: 3 },
								[theme.breakpoints.down('md')]: {
									mx: '0',
								},
							})}
						>
							<Box>
								<Typography variant='h6' fontWeight='lighter'>
									Thank you for requesting a quote with Street Cover today for a change on your policy. Unfortunately,
									we are unable to progress with the proposed change at this time.
								</Typography>
							</Box>
							<Typography
								variant='body1'
								sx={(theme) => ({
									m: 2,
									[theme.breakpoints.down('md')]: { m: 'unset', mt: 2 },
								})}
							>
								Please contact us on{' '}
								<Typography component='a' href='tel:01704795185' color='primary' fontWeight='bold'>
									01704 795 185
								</Typography>{' '}
								if you wish to discuss your change.
							</Typography>
							<Typography>
								Thank you for your interest in Street Cover - we look forward to speaking to you soon.
							</Typography>
						</Box>
						<Button startIcon={<Home />} size='large' variant='contained' onClick={() => navigate('/portal/home')}>
							Return to homepage
						</Button>
						<Box sx={{ margin: 2 }} />
					</Box>
				</Box>
			</Fade>
		</Paper>
	);
};

export default MtaReferralPage;
